export default {
  sucursales: [],
  sucursal: null,
  caja: null,
  arqueoCaja: null,
  configuracion: null


}